"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineSVGDraw = void 0;
const mithril_1 = require("../mithril");
const theme_1 = require("../theme");
const label_draw_svg_1 = require("./label.draw.svg");
const util_draw_svg_1 = require("./util.draw.svg");
const util_draw_svg_2 = require("./util.draw.svg");
const MARKER_CIRCLE_RADIUS = 6;
function getPointStyle(isInsight, isHovered, isSelected) {
    var pointFillColor = theme_1.StyleConfig.LABEL.FILL;
    var pointStrokeColor = theme_1.StyleConfig.LABEL.STROKE;
    if (isInsight) {
        pointFillColor = theme_1.StyleConfig.LABEL.FILL_INSIGHT;
        if (isHovered) {
            pointStrokeColor = theme_1.StyleConfig.LABEL.FILL_INSIGHT;
        }
        else {
            pointStrokeColor = theme_1.StyleConfig.STROKE;
        }
    }
    else {
        if (isHovered) {
            pointFillColor = theme_1.StyleConfig.LABEL.FILL_HIGHLIGHTED;
        }
        else if (isSelected) {
            pointFillColor = theme_1.StyleConfig.LABEL.FILL_SELECTED;
            pointStrokeColor = theme_1.StyleConfig.STROKE;
        }
    }
    return {
        fill: pointFillColor,
        stroke: pointStrokeColor,
    };
}
class LineSVGDraw {
    static view(node, options) {
        const startPoint = node.start;
        const endPoint = node.end;
        const label = node.label;
        const selectedId = options.draw.state.selectedId;
        const hoverId = options.draw.state.hoverId;
        // If the current element is an insight one, but we don't have the ability to view them, then don't render it.
        if (node.isInsightMeasurement && !options.isInsightMarkersVisible) {
            return null;
        }
        const isStartSelected = selectedId === startPoint.id;
        const isEndSelected = selectedId === endPoint.id;
        const isSelected = selectedId === node.id || isStartSelected || isEndSelected;
        const isHovered = hoverId === node.id || hoverId === startPoint.id || hoverId === endPoint.id;
        const isActive = isSelected || isHovered;
        const classNames = [
            theme_1.ClassNames.line.container,
            isSelected ? theme_1.ClassNames.isSelected : null,
            isHovered ? theme_1.ClassNames.isHighlighted : null,
        ];
        const startPointClassNames = [
            theme_1.ClassNames.line.start,
            isStartSelected ? theme_1.ClassNames.isSelected : null,
            isStartSelected ? theme_1.ClassNames.point.isSelected : null,
        ];
        const startPointStyle = getPointStyle(node.isInsightMeasurement, hoverId === startPoint.id, isStartSelected || selectedId === node.id);
        const endPointClassNames = [
            theme_1.ClassNames.line.end,
            isEndSelected ? theme_1.ClassNames.isSelected : null,
            isEndSelected ? theme_1.ClassNames.point.isSelected : null,
        ];
        const endPointStyle = getPointStyle(node.isInsightMeasurement, hoverId === endPoint.id, isEndSelected);
        const children = [
            util_draw_svg_2.SVGUtil.DrawLineMain(startPoint, endPoint, options.scale),
            util_draw_svg_2.SVGUtil.DrawLineSecondary(startPoint, endPoint, options.scale, node.isInsightMeasurement ? theme_1.StyleConfig.STOKE_SECONDARY_INSIGHT : theme_1.StyleConfig.STROKE_SECONDARY),
            label_draw_svg_1.LabelSVGDraw.view(label, options),
            util_draw_svg_2.SVGUtil.DrawMoveLine(startPoint, endPoint, options.scale, util_draw_svg_1.IkeDrawLabel.LABEL),
            isActive
                ? util_draw_svg_2.SVGUtil.DrawPoint(startPoint, {
                    className: startPointClassNames.join(' '),
                    label: util_draw_svg_1.IkeDrawLabel.START,
                    radius: options.scale * MARKER_CIRCLE_RADIUS,
                    scale: options.scale,
                    fill: startPointStyle.fill,
                    stroke: startPointStyle.stroke,
                    draggable: true,
                    nodeId: startPoint.id,
                })
                : null,
            isActive
                ? util_draw_svg_2.SVGUtil.DrawPoint(endPoint, {
                    className: endPointClassNames.join(' '),
                    label: util_draw_svg_1.IkeDrawLabel.END,
                    radius: options.scale * MARKER_CIRCLE_RADIUS,
                    scale: options.scale,
                    fill: endPointStyle.fill,
                    stroke: endPointStyle.stroke,
                    draggable: true,
                    nodeId: endPoint.id,
                })
                : null,
        ];
        return (0, mithril_1.m)('g', {
            key: node.id,
            className: classNames.join(' '),
            'c-Draw-node-id': node.id,
            'c-Draw-tag': 'line',
        }, children);
    }
}
exports.LineSVGDraw = LineSVGDraw;
//# sourceMappingURL=line.draw.svg.js.map